import * as React from 'react';

const QueuedActionItem24: React.FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<rect width='26' height='26' rx='13' fill='white' />
		<rect x='0.5' y='0.5' width='25' height='25' rx='12.5' stroke='black' strokeOpacity='0.1' />
	</svg>
);

export default QueuedActionItem24;
